export function getstatusshippingtyle(sale) {
  const statuses = {
    preparing: {
      label_top: 'Preparing',
      desc: 'Getting ready',
      icon: { color: 'td-red-icon', svg: 'hammer' }
    },
    'ready to pickup': {
      label_top: 'Ready',
      desc: 'To Pickup',
      icon: { color: 'td-green-icon', svg: 'check-round' }
    },
    shipped: {
      label_top: 'Shipped',
      desc: 'On Way',
      icon: { color: 'td-green-icon', svg: 'truck' }
    },
    delivered: {
      label_top: 'Delivered',
      desc: 'Dispatched',
      icon: { color: 'td-gray-icon', svg: 'check-round' }
    }
  }

  return statuses[sale.shipping_status] || {
    label_top: '',
    desc: '',
    icon: { color: '', svg: '' }
  }
}

export function getstatuspaymentstyle(sale) {
  let status

  switch (sale.payment_status) {
    case 'paid':
      status = {
        label_top: 'Paid',
        desc: 'No action needed',
        icon: { color: 'td-green-icon', svg: 'cash' }
      }
      break
    case 'unpaid':
      status = sale.shipping_status === 'delivered'
        ? {
            label_top: 'Unpaid',
            desc: 'Payment needed',
            icon: { color: 'td-orange-icon', svg: 'cash' }
          }
        : {
            label_top: '--',
            desc: 'No Payment needed',
            icon: { color: 'td-gray-icon', svg: 'cash' }
          }
      break
    case 'partially_paid':
      status = {
        label_top: 'Partially paid',
        desc: 'Payment needed',
        icon: { color: 'td-orange-icon', svg: 'cash' }
      }
      break
    case 'close':
      status = {
        label_top: 'Close',
        desc: 'No action needed',
        icon: { color: 'td-gray-icon', svg: 'cash' }
      }
      break
    case 'credited':
      status = {
        label_top: 'Credited',
        desc: 'Outstanding credit',
        icon: { color: 'td-orange-icon', svg: 'cash' }
      }
      break
    default:
      status = {
        label_top: '',
        desc: '',
        icon: { color: 'td-white-icon', svg: 'cash' }
      }
  }

  const isOverdue = !['paid', 'credited'].includes(sale.payment_status) &&
    Number.parseInt(sale.remaining_days, 10) <= 0

  if (isOverdue) {
    return {
      label_top: 'Overdue',
      desc: 'Payment needed',
      icon: { color: 'td-red-icon', svg: 'cash' }
    }
  }

  return status
}
